import {Action} from "@ngrx/store";
import {IActivityNotification} from "../../activity-notifications/activity-notification";
import {IWebsiteActivityNotificationsState} from "../reducers/activity-notifications.reducer";

export const LOAD_ACTIVITY_NOTIFICATIONS: string = '[activityNotifications] Load Activity Notifications';
export const LOAD_ACTIVITY_NOTIFICATIONS_SUCCESS: string = '[activityNotifications] Load Activity Notifications Success';
export const LOAD_ACTIVITY_NOTIFICATIONS_FAIL: string = '[activityNotifications] Load Activity Notifications Fail';
export const INIT_ACTIVITY_NOTIFICATIONS_SOCKET: string = '[activityNotifications] Init Activity Notifications Socket';

export const ADD_ACTIVITY_NOTIFICATION: string = '[activityNotifications] Add Activity Notification';
export const DEACTIVATE_ACTIVITY_NOTIFICATION: string = '[activityNotifications] Deactivate Activity Notification';
export const REMOVE_ACTIVITY_NOTIFICATION: string = '[activityNotifications] Remove Activity Notification';

export const MARK_READ_ACTIVITY_NOTIFICATIONS: string = '[activityNotifications] Mark Read Activity Notifications';

export const TOGGLE_ACTIVITY_NOTIFICATIONS: string = '[activityNotifications] Toggle Activity Notifications';

export class LoadActivityNotifications implements Action {

  readonly type: string = LOAD_ACTIVITY_NOTIFICATIONS;

}

export class LoadActivityNotificationsSuccess implements Action {

  readonly type: string = LOAD_ACTIVITY_NOTIFICATIONS_SUCCESS;
  constructor(public payload: {
    [websiteId: number]: IWebsiteActivityNotificationsState
  }) {}

}

export class LoadActivityNotificationsFail implements Action {

  readonly type: string = LOAD_ACTIVITY_NOTIFICATIONS_FAIL;
  constructor(public payload: string) {}

}

export class InitActivityNotificationsSocket implements Action {

  readonly type: string = INIT_ACTIVITY_NOTIFICATIONS_SOCKET;

}

export class AddActivityNotification implements Action {

  readonly type: string = ADD_ACTIVITY_NOTIFICATION;
  constructor(public payload: IActivityNotification) {}

}
export class DeactivateActivity implements Action {

  readonly type: string = DEACTIVATE_ACTIVITY_NOTIFICATION;
  constructor(public payload: IActivityNotification) {}

}
export class RemoveActivityNotification implements Action {

  readonly type: string = REMOVE_ACTIVITY_NOTIFICATION;
  constructor(public payload: IActivityNotification) {}

}

export class MarkReadActivityNotifications implements Action {

  readonly type: string = MARK_READ_ACTIVITY_NOTIFICATIONS;

}

export class ToggleActivityNotifications implements Action {

  readonly type: string = TOGGLE_ACTIVITY_NOTIFICATIONS;
  constructor(public payload?: boolean) {}

}

export type ActivityNotificationsAction = LoadActivityNotifications | LoadActivityNotificationsSuccess | LoadActivityNotificationsFail | AddActivityNotification | DeactivateActivity | RemoveActivityNotification | ToggleActivityNotifications;
